<template>
  <div class="login">
    <h1> Logga in </h1>
    <label >
      <b-form-input class="loginInput" type="text" v-model="email" placeholder="Email" autofocus />
    </label>
    <label>
      <b-form-input class="loginInput" type="password" v-model="password" placeholder="Password"/>
    </label>

        <b-alert class="mt-5" show variant="danger" v-show="false"> Felaktig inloggning </b-alert>

      <b-button @click="login" class="turqouse">Logga in</b-button>

        <div class="message">Har du inget konto ? <br>

          <router-link to="/sign-up" class="a">Skapa konto</router-link>
        </div>
        <hr class="my-4">
  </div>
</template>

<script>
  import { login } from '../css/login.scss'; //eget stylesheet för login och sign-up

  import firebase from 'firebase';
  export default {
    name: 'Login',
    components: { },
    data() {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      async login () {
      await firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          (user) => {
            this.$router.replace('forsyn-list')
          },
          (err) => {
            alert('Oops. ' + err.message)
          }
        );
      }
    }
  }
</script>

<style scoped lang="scss">
  .login {
      a {
        color: #4CAF50;
      }
    }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue